var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89265 6.72333L7.99997 3.616L11.1088 6.72467L12.9167 4.91667L7.99997 0L3.08479 4.9152L4.89272 6.7232L4.89265 6.72333ZM0 8L1.80806 6.19168L3.61599 7.99962L1.80793 9.80768L0 8ZM4.89265 9.27686L7.99997 12.384L11.1087 9.27539L12.9176 11.0824L12.9167 11.0834L7.99997 16L3.08479 11.0848L3.08223 11.0822L4.89284 9.27667L4.89265 9.27686ZM12.384 8.00077L14.192 6.1927L15.9999 8.00064L14.1919 9.8087L12.384 8.00077Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83336 7.99905H9.83413L7.99964 6.16443L6.64368 7.52001L6.4879 7.67585L6.16662 7.9972L6.16406 7.99969L6.16662 8.00232L7.99964 9.8356L9.83426 8.00097L9.83515 7.99995L9.83349 7.99905",
    fill: "#F3BA2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.6ab33720.svg";
export { ForwardRef as ReactComponent };